module.exports = __webpack_public_path__ + "static/img/tab1.e86a7c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tab1.jpg
// module id = 3141
// module chunks = 1